import PartyWidget from '@components/widgets/party/party';
export default PartyWidget;
